import { render, staticRenderFns } from "./DashboardCx.vue?vue&type=template&id=409b99b1"
import script from "./DashboardCx.vue?vue&type=script&lang=js"
export * from "./DashboardCx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports